import React, { useState, useEffect } from "react";

import Slider from "react-slick";

import { firstEventDate, events, eventStatus } from "@utils/schedule";
import classnames from "@utils/classnames";
import Container from "@components/container";
import Section from "@components/section";
import Box from "@components/box";
import Clickable from "@components/clickable";
import Calendar from "@components/calendar";
import Games from "@components/games";

import styles from "./events.module.scss";
import gameCompnaniesImage from "@images/game-campanies.jpg";

const renderCompanies = () => {
  return (
    <div>
      <a href={gameCompnaniesImage} target="_blank">
        <img
          className={classnames("fluidImage", styles.gameCompnanies)}
          src={gameCompnaniesImage}
          alt="参展公司"
        />
      </a>
      <p style={{ textAlign: "center", margin: "15px 0 0", fontSize: "17px" }}>
        （以上排名不分先后）
      </p>
    </div>
  );
};

const renderCalendarContent = (event, calendar, hasGames = false) => {
  if (event.date === firstEventDate && !hasGames) {
    return renderCompanies();
  }

  return null;
};

const useRenderTabContent = event => {
  const [hasGames, setHasGames] = useState(false);
  if (!event.calendars) {
    return (
      <p
        key={event.date}
        style={{ textAlign: "center", padding: "20px 10px", fontSize: "20px" }}
      >
        COMING SOON
      </p>
    );
  }

  let rc = event.calendars
    // .filter(c => c.firstExpress)
    .map(c => {
      const [_, streaming] = eventStatus(event, c);
      return (
        <Calendar
          key={`${event.date}${c.title}${c.time}`}
          {...c}
          color={event.color}
          streaming={streaming}
        >
          {renderCalendarContent(event, c, hasGames)}
        </Calendar>
      );
    });

  if (event.date === "8.5") {
    rc = (
      <>
        {rc}
        <Games onUpdate={() => setHasGames(true)} />
        {hasGames && <Box color={event.color}>{renderCompanies()}</Box>}
      </>
    );
  }

  return rc;
};

const Events = () => {
  const [tab, setTab] = useState(events[0]);
  const [sliderKey, setSliderKey] = useState("init");

  useEffect(() => {
    setTimeout(() => {
      setSliderKey("inited");
    }, 1000);
  }, []);

  const tabsOptions = {
    slidesToShow: 4,
    // nextArrow: (
    //   <Clickable className={classnames(styles.arrow, styles.arrowNext)}>
    //     <img src={arrowImage} className="flipx" />
    //   </Clickable>
    // ),
    // prevArrow: (
    //   <Clickable className={styles.arrow}>
    //     <img src={arrowImage} />
    //   </Clickable>
    // ),
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          variableWidth: true,
          infinite: false
        }
      }
    ],
    afterChange: current => {
      const nextEvent = events[current];
      if (!nextEvent.comingsoon) {
        setTab(nextEvent);
      }
    }
  };
  return (
    <Container>
      <Section title={[["UPCOMING", "EVENTS"], ["节目预告"]]}>
        <div className={styles.wrapper}>
          <div className={styles.tabs}>
            <Slider key={sliderKey} {...tabsOptions}>
              {events.map(event => {
                const isChosen = event.date === tab.date;
                const [isToday] = eventStatus(event);
                return (
                  <div key={event.date}>
                    <Clickable
                      className={classnames(styles.eventTab, {
                        [styles.tabComing]: event.comingsoon
                      })}
                      onClick={() => {
                        setTab(event);
                      }}
                    >
                      <Box
                        color={event.color}
                        thick={isChosen}
                        thin={!isChosen}
                        texture={isToday ? "arrow" : "spot"}
                      >
                        <div className={styles.tabText}>
                          <p>DATE</p>
                          <h3>
                            <span>{event.date}</span>
                            <span className={styles.dateDetail}>
                              {event.comingsoon ? (
                                <>
                                  COMING
                                  <br />
                                  SOON
                                </>
                              ) : (
                                event.calendars[0].time.replace(" 开始", "")
                              )}
                            </span>
                          </h3>
                        </div>
                      </Box>
                    </Clickable>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
        <div className={styles.event}>{useRenderTabContent(tab)}</div>
      </Section>
    </Container>
  );
};

export default Events;
